import React from 'react';

const PaymentPage: React.FC = () => {
  return (
    <div className="w-full bg-neutral-white flex items-center justify-center h-[calc(100vh-5rem)]">
      <img
        src="/images/payment/RAISE-BAR-CODE.jpg"
        alt="RAISE UPI QR Code"
        className="h-full w-full object-contain"
      />
    </div>
  );
};

export default PaymentPage;


